export default "__VITE_ASSET__7af288cd__"